export enum OcbLocalAgentCommand {
    GetStatus = 0,
    Start = 1,
    Stop = 2,
    Restart = 3,
    RefreshSettings = 4,
    CheckConnection = 5,
    ListOfFiles = 6,
    ExecuteTransfer = 7,
    ExecuteTransfers = 8,
    SendArchivedFileByEmail = 9,
    DeleteArchivedFile = 10,
}
